export type AnalyticsConsent = 'pending' | 'granted' | 'denied';

export const ANALYTICS_CONSENT_STORAGE_KEY = 'imabird.analytics-consent.v1';

export const readAnalyticsConsent = (storage: Pick<Storage, 'getItem'>): AnalyticsConsent => {
  const saved = storage.getItem(ANALYTICS_CONSENT_STORAGE_KEY);
  return saved === 'granted' || saved === 'denied' ? saved : 'pending';
};

export const saveAnalyticsConsent = (
  storage: Pick<Storage, 'setItem'>,
  consent: Exclude<AnalyticsConsent, 'pending'>,
): void => {
  storage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, consent);
};
